import { IAppState } from '../state/app.state';
import { ICompanyEmployeeState } from '../state/companyEmployee.state';
import { createSelector } from '@ngrx/store';
import { state } from '@angular/animations';
import { isComputedPropertyName } from 'typescript';

const selectcompanyEmployee = (state: IAppState) => state.companyEmployee;

export const getAllCompanyEmployesSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllCompanyEmployesSuccess
);

export const getAllCompanyEmployesError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllCompanyEmployesError?.error || state.getAllCompanyEmployesError
);

export const getAllCompanyEmployesByRolesSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllCompanyEmployesByRolesSuccess
);

export const getAllCompanyEmployesByRolesError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllCompanyEmployesByRolesError?.error || state.getAllCompanyEmployesByRolesError
);

export const getAddCompanyEmployeeSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAddCompanyEmployeeSuccess
);

export const getAddCompanyEmployeeError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) =>  state.getAddCompanyEmployeeError?.error || state.getAddCompanyEmployeeError
);

export const getEditCompanyEmployeeSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getEditCompanyEmployeeSuccess
);

export const getEditCompanyEmployeeError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getEditCompanyEmployeeError?.error || state.getEditCompanyEmployeeError
);

export const getLoginCompanyEmployeeSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getLoginCompanyEmployeeSuccess
);

export const getLoginCompanyEmployeeError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getLoginCompanyEmployeeError?.error || state.getLoginCompanyEmployeeError
);

export const sendLinkComapanyEmployeeFrgtPswdSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) =>
    state.sendLinkComapanyEmployeeFrgtPswdSuccess
);

export const sendLinkComapanyEmployeeFrgtPswdError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.sendLinkComapanyEmployeeFrgtPswdError?.error || state.sendLinkComapanyEmployeeFrgtPswdError
);

export const getComapanyEmployeeFrgtresetPasswordSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) =>
    state.getComapanyEmployeeFrgtresetPasswordSuccess
);

export const getComapanyEmployeeFrgtresetPasswordError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) =>
    state.getComapanyEmployeeFrgtresetPasswordError?.error || state.getComapanyEmployeeFrgtresetPasswordError
);

export const getEmployeesToAddMasterUserSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getEmployeesToAddMasterUserSuccess
);

export const setCompanyEmployeesErrorMsg = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.setCompanyEmployeesErrorMsg?.error || state.setCompanyEmployeesErrorMsg
);
export const getEmployeesToAddSubUserSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getEmployeesToAddSubUserSuccess
);
export const getEmployeesToAddSubUserError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getEmployeesToAddSubUserError?.error || state.getEmployeesToAddSubUserError
);
export const getRemoveCmpyUsersSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getRemoveCmpyUsersSuccess
);

export const getRemoveCmpyUsersError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getRemoveCmpyUsersError?.error || state.getRemoveCmpyUsersError
);
export const getRemoveUserRolesSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getRemoveUserRolesSuccess
);

export const getRemoveUserRolesError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getRemoveUserRolesError?.error || state.getRemoveUserRolesError
);

export const getRoleUserSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getRoleUserSuccess
);

export const getRoleUserError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getRoleUserError?.error || state.getRoleUserError
);
export const getAllSalesControllerUsersSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllSalesControllerUsersSuccess
);
export const getAllSalesControllerUsersError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllSalesControllerUsersError?.error || state.getAllSalesControllerUsersError
);
export const getAllWarehouseControllerUsersSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllWarehouseControllerUsersSuccess
);
export const getAllWarehouseControllerUsersError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllWarehouseControllerUsersError?.error || state.getAllWarehouseControllerUsersError
);

export const getAllwarehouseandproductionUsersSuccess = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) =>
    state.getAllwarehouseandproductionUsersSuccess
);
export const getAllwarehouseandproductionUsersError = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllwarehouseandproductionUsersError?.error || state.getAllwarehouseandproductionUsersError
);

export const getAllCompanyEmployesInProgress = createSelector(
  selectcompanyEmployee,
  (state: ICompanyEmployeeState) => state.getAllCompanyEmployesInProgress
);
